import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import {
  ACCESS_TOKEN_NAME,
  REFRESH_TOKEN_NAME,
  PageSize,
} from "../../shared/constant";
import Endpoint from "../../shared/endpoints";
import globalUtils from "../../utils/globalUtils";
import userConstants from "../constants/userConstants";

const getUsers = (payload: any) => {
  return api.get(
    `${Endpoint.retrieveUsers}/?page=${payload.page}&search=${payload.searchText}&page_size=${PageSize.DEFAULT}`,
  );
};
const getUserSignup = (payload: any) =>
  api.get(Endpoint.getUserSignup, {
    params: {
      page: payload.page,
      ...(payload.searchText && { search: payload.searchText }),
      ...(payload.status && { status: payload.status }),
      ...(payload.category && { category: payload.category }),
    },
  });
const updateSignupRequest = (payload: any) =>
  api.patch(`${Endpoint.updateSignupRequest}/${payload.id}/`, payload.body);
const sendSingupRequest = (payload: any) =>
  api.post(Endpoint.sendSingupRequest, payload);
const addUser = (payload: any) => {
  return api.post(Endpoint.createUser, payload);
};
const editUser = (payload: any) => {
  return api.patch(`${Endpoint.editUser}/${payload.id}/`, payload.body);
};

const login = (payload: any) => api.post(Endpoint.login, payload);
const logout = (payload: any) => api.post(Endpoint.logout, payload);
const refreshToken = (payload: any) => api.post(Endpoint.refreshToken, payload);

function* retrieveUsers(action: any) {
  try {
    const response: AxiosResponse = yield call(getUsers, action.payload);
    yield put({
      type: userConstants.GET_USERS_LIST_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.GET_USERS_LIST_FAILURE, err: e });
  }
}

function* getUserSignupAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getUserSignup, action.payload);
    yield put({
      type: userConstants.GET_USER_SIGNUP_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.GET_USER_SIGNUP_FAILURE, err: e });
  }
}

function* updateSignupRequestAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      updateSignupRequest,
      action.payload,
    );
    yield put({
      type: userConstants.UPDATE_SIGNUP_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.UPDATE_SIGNUP_FAILURE, err: e });
  }
}

function* sendSingupRequestAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      sendSingupRequest,
      action.payload,
    );
    yield put({
      type: userConstants.SEND_USER_SIGNUP_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.SEND_USER_SIGNUP_FAILURE, err: e });
  }
}

function* createUser(action: any) {
  try {
    const response: AxiosResponse = yield call(addUser, action.payload);
    yield put({
      type: userConstants.CREATE_USER_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.CREATE_USER_FAILURE, err: e });
  }
}

function* retrieveUserDetails() {
  try {
    const response: AxiosResponse = yield api.get(Endpoint.userDetails);
    yield put({
      type: userConstants.GET_USER_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.GET_USER_DETAILS_FAILURE, err: e });
  }
}

function* editUserAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(editUser, action.payload);
    yield put({
      type: userConstants.EDIT_USER_SUCCESS,
      payload: response,
    });
    yield call(retrieveUserDetails);
  } catch (e) {
    yield put({ type: userConstants.EDIT_USER_FAILURE, err: e });
  }
}

function* retrieveUserRoles() {
  try {
    const response: AxiosResponse = yield api.get(Endpoint.retrieveRoles);
    yield put({
      type: userConstants.GET_ROLES_LIST_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.GET_ROLES_LIST_FAILURE, err: e });
  }
}

function* loginAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(login, action.payload);
    yield put({
      type: userConstants.LOGIN_SUCCESS,
      payload: response,
    });
    localStorage.setItem(ACCESS_TOKEN_NAME, response.data.access);
    localStorage.setItem(REFRESH_TOKEN_NAME, response.data.refresh);
    yield call(retrieveUserDetails);
  } catch (e) {
    yield put({ type: userConstants.LOGIN_FAILURE, err: e });
  }
}

function* logoutAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(logout, action.payload);
    yield put({
      type: userConstants.LOGOUT_SUCCESS,
      payload: response,
    });
    globalUtils.removeTokens();
  } catch (e) {
    yield put({ type: userConstants.LOGOUT_FAILURE, err: e });
  }
}

function* refreshTokenAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(refreshToken, action.payload);
    yield put({
      type: userConstants.REFRESH_TOKEN_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: userConstants.REFRESH_TOKEN_FAILURE, err: e });
  }
}

function* userSaga() {
  yield all([takeEvery(userConstants.GET_USERS_LIST, retrieveUsers)]);
  yield all([
    takeEvery(userConstants.GET_USER_SIGNUP_REQUEST, getUserSignupAsync),
  ]);
  yield all([
    takeEvery(userConstants.UPDATE_SIGNUP_REQUEST, updateSignupRequestAsync),
  ]);
  yield all([
    takeEvery(userConstants.SEND_USER_SIGNUP_REQUEST, sendSingupRequestAsync),
  ]);
  yield all([takeEvery(userConstants.GET_USER_DETAILS, retrieveUserDetails)]);
  yield all([takeEvery(userConstants.CREATE_USER_REQ, createUser)]);
  yield all([takeEvery(userConstants.EDIT_USER_REQUEST, editUserAsync)]);
  yield all([takeEvery(userConstants.GET_ROLES_LIST, retrieveUserRoles)]);
  yield all([takeEvery(userConstants.LOGIN_REQUEST, loginAsync)]);
  yield all([takeEvery(userConstants.LOGOUT_REQUEST, logoutAsync)]);
  yield all([
    takeEvery(userConstants.REFRESH_TOKEN_REQUEST, refreshTokenAsync),
  ]);
}

export default userSaga;
